import { render, staticRenderFns } from "./universityChange.vue?vue&type=template&id=3d17e01a&"
import script from "./universityChange.vue?vue&type=script&lang=js&"
export * from "./universityChange.vue?vue&type=script&lang=js&"
import style0 from "./universityChange.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports